import { api } from "./index";

export interface EvaluationScore {
  id: string | null;
  bidSubmissionId: string;
  criteriaId: string;
  score: number;
  notes?: string | null;
  criteria?: {
    id: string;
    criteriaName: string;
    criteriaType: 'FINANCIAL' | 'GENERAL';
    weightage: number;
  };
}

export interface SaveScoresDto {
  scores: Array<{
    criteriaId: string;
    score: number;
    notes?: string;
  }>;
}

export interface BulkSaveScoresDto {
  submissions: Array<{
    bidSubmissionId: string;
    scores: Array<{
      criteriaId: string;
      score: number;
      notes?: string;
    }>;
  }>;
}

export const evaluationScoresApi = {
  // Get scores for a bid submission
  getBidSubmissionScores: async (tenderId: string, bidSubmissionId: string): Promise<EvaluationScore[]> => {
    const response = await api.get(`/tenders/${tenderId}/bid-submissions/${bidSubmissionId}/scores`);
    return response.data;
  },

  // Save scores for a bid submission
  saveBidSubmissionScores: async (
    tenderId: string,
    bidSubmissionId: string,
    data: SaveScoresDto
  ): Promise<EvaluationScore[]> => {
    const response = await api.post(`/tenders/${tenderId}/bid-submissions/${bidSubmissionId}/scores`, data);
    return response.data;
  },

  // Bulk save scores for multiple bid submissions
  bulkSaveEvaluationScores: async (
    tenderId: string,
    data: BulkSaveScoresDto
  ): Promise<{ message: string }> => {
    const response = await api.post(`/tenders/${tenderId}/evaluation-scores/bulk`, data);
    return response.data;
  },

  // Update evaluation notes for a bid submission
  updateEvaluationNotes: async (
    tenderId: string,
    bidSubmissionId: string,
    evaluationNotes: string
  ): Promise<{ id: string; evaluationNotes: string | null }> => {
    const response = await api.put(`/tenders/${tenderId}/bid-submissions/${bidSubmissionId}/evaluation-notes`, {
      evaluationNotes,
    });
    return response.data;
  },
};
